var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"NavbarPC"},[_c('NavbarPC')],1),_c('div',{staticClass:"NavbarMoblie"},[_c('NavbarMoblie')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }